import React from 'react';
import TeamMembers from './TeamMembers';
import Sowmya from '../Images/Sowmya.jpeg';
import Rahul from '../Images/Rahul.jpeg';
import Lenin from '../Images/Lenin.jpeg';
import Swati from '../Images/Swati.jpeg';
import Pranathi from '../Images/Pranathi.jpeg';
import Subha from '../Images/Subha.jpeg';
import Ketan from '../Images/Ketan.jpeg';
import './Team.css';

const team = [
    {
        name: 'Dr. Sowmya Brundavanam ',
        role: 'Masters in Pediatric Physiotherapy',
        image: Sowmya,
        details: [
            "Worked  3.5 years in Prettislim clinic   with a multidisciplinary team in corporate setup to help clients with obesity  to reach their optimal weight .Worked  in AquaCentric Andheri West in a clinical aqua based setup to deal with clients having varied health issues involving orthopedic, neurological , paediatric issues .Volunteer at an NGO  Aastha  dealing with underprivileged special kids and their rehabilitation .Currently giving telerehab to pregnant women ,women having pcos issues and post partum issues.",
        ],
    },
    {
        name: 'Dr. Rahul Gupta',
        role: 'Physiotherapist',
        image: Rahul,
        details: [
            "BPT (RGUHS) | Certified : CKTT, CDNT, CCT",
            "Dr. Rahul,PT is a dedicated Physiotherapist, passionate about integrating cutting-edge science with clinical expertise to revolutionize patient outcomes.With a strong foundation in clinical practice; Dr.Rahul  has developed expertise in assessing and treating various sports, musculoskeletal and neurological conditions.",
        ],
    },
    {
        name: 'Mr. Lenin Mallick',
        role: 'Speech-Language therapist',
        image: Lenin,
        details: [
            "BASLP | AYJNISHD (SRC)",
            "Lenin Mallick is a qualified Speech-Language Therapist holding a Bachelor of Audiology and Speech-Language Pathology (BASLP) from the prestigious Ali Yavar Jung National Institute of Speech and Hearing Disabilities (AYJNISHD - SRC),Hyderabad.Mr.Mallick possesses practical clinical experience in diverse rehabilitation settings.He began his career providing speech therapy services at Total Rehabilitation in Hyderabad.Currently, he is practicing as a Speech - Language Pathologist at Restora Rehab Care in Bhubaneswar, where he delivers evidence - based therapeutic interventions to clients.",
        ],
    },
    {
        name: 'Dr. Swatirekha Swain',
        role: 'Pediatric Rehabilitation Specialist',
        image: Swati,
        details: [
            "SVNIRTAR  (BOT, MOT-Rehab) |  Pediatric Clinical Experience ",
            "Dr. Swatirekha Swain is a dedicated Occupational Therapist specializing in rehabilitation, with a growing expertise in pediatric practice. She holds both a Bachelor of Occupational Therapy (BOT) and a Master of Occupational Therapy (MOT) in Rehabilitation from the esteemed SVNIRTAR in Cuttack, Odisha.Working as a Senior Occupational therapist in Knowledge Rehabilitation & Inclusive Solutions (KRIS),Hyderabad.",
        ],
    },
    {
        name: 'Ms. Pranathi Kalvakalu',
        role: 'Lead Nutritionist',
        image: Pranathi,
        details: [
            "M.Sc in Sports Nutrition, National Institute of Nutrition - ICMR",
            "BSc in Applied Nutrition, Public Health, and Biochemistry",
            "Lead Nutritionist at Sports Authority of Gujarat, High Performance Center - Nadiad.Formerly with Sports Authority of Gujarat, Center for Excellence - - Himmatnagar.Former Sports Nutritionist at Center for Sports Science, Sree Kanteerava Stadium & Basavanagudi Aquatic Center,Bangalore.Pranathi brings a wealth of knowledge and experience to her clients, helping athletes, fitness enthusiasts, and individuals achieve their nutrition goals with science-backed, personalized plans.",
        ],
    },
    {
        name: 'Mr. Subhajit Chatterjee',
        role: 'Sports Nutritionist | Performance Nutritionist',
        image: Subha,
        details: [
            "M.Sc Sports Nutrition (CURAJ, Gold Medalist) | B.Sc. Nutrition Honours ",
            "Subhajit Chatterjee is a Sports Nutritionist with proven expertise in optimizing performance and recovery for elite athletes through evidence-based strategies. His experience in high-performance environments enables him to provide personalized nutrition guidance for individuals seeking to enhance their health, fitness, or manage specific medical conditions."
        ],
    },
    {
        name: 'Mr. Ketan Joga',
        role: 'Strength & Conditioning Professional | Educator | Former Athlete',
        image: Ketan,
        details: [
            "I’m a qualified Strength & Conditioning professional with over 6+ years of experience working with athletes across levels. I hold a Postgraduate Diploma in Strength & Conditioning and a Diploma in Olympic Lifting from NSNIS Patiala, under the Sports Authority of India.Internationally certified by the leading Organisations, I combine global standards with local context. I’ve represented India in American Football at the World Championships and currently serve as a Guest Lecturer at LNIPE, Gwalior, guiding future coaches.",
        ],
    },
];

function Team() {
    return (
        <section id="team" className="team">
            <h2>Meet Our Team</h2>
            <div className="scroll-wrapper">
                <div className="card-container">
                    {team.map((member, index) => (
                        <TeamMembers key={index} {...member} />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Team;
